<template>
  <b-modal size='xl' hide-footer v-model="mostrarModal" :title="prefix + title" @hide="fecharModal">
    <b-form @submit.prevent="submitForm">
      <b-card bg-variant="light">
        <b-row>
          <b-col>
            <b-form-group label="Tombamento SPALM">
              <b-form-input v-model="localIbp.numTombamento" disabled required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Descrição Produto">
              <b-form-input v-model="localIbp.descricaoResumida" disabled
                required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols='6'>
            <b-form-group label="Tombamento SAMP">
              <b-form-input v-model="localIbp.s_numTombAntigo" disabled required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card bg-variant="light">
        <b-row>
          <b-col cols='4'>
            <b-form-group label="Data: *">
              <b-form-input type="date" v-model="form.dataAgregacaoFormatado" :state='validateState("dataAgregacaoFormatado")'
                required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols='4'>
            <b-form-group label="Descrição Agregação: *">
              <b-form-textarea v-model="form.descricao" :state='validateState("descricao")' required></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col cols='3'>
            <b-form-group>
              <LgFinderPageMotivoAgregacao v-model="form.motivo" :prefix="prefix + title + ' > '" :error="$v.form.motivo"
                id="finderPageMotivo" label="Motivo Agregação: *" invalidFeedback="Motivo deve ser informado!"
                cols="12">
              </LgFinderPageMotivoAgregacao>
            </b-form-group>
          </b-col>
          <b-col cols='1' class='d-flex align-items-center justify-content-center'>
            <LgFinderPageItemBemPermanente v-model="form.itembem" :prefix="[prefix+ title]" @onselect='itemBemPermanenteSelect'
              :error="$v.form.itembem" id="ItemBemPermanente" cols="12" mode='button'>
            </LgFinderPageItemBemPermanente>
          </b-col>
        </b-row>
        <b-table responsive class="mt-2" small :items="this.form.itensBemPermanenteAgregacao" :fields="this.fields" :busy="this.busy">
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>
          <template #cell(tombamento)="data">
            {{ data.item.tombamento }}
          </template>
          <template #cell(numSerie)="data">
            {{ data.item.numSerie }}
          </template>
          <template #cell(numProduto)="data">
            {{ data.item.numProduto }}
          </template>
          <template #cell(descricao)="data">
            {{ data.item.descricao }}
          </template>
          <template #cell(actions)="data">
            <b-button variant="danger" size="sm" @click="removeItem(data.item)">
              <b-icon icon="trash"></b-icon>
            </b-button>
          </template>
        </b-table>
      </b-card>

      <div class="d-flex justify-content-center mt-3">
        <b-button id="salvarEmpenho" class=" my-2" size="sm" pill variant="success" @click="submitForm">
          <b-icon icon="check-circle" />
          <b-tooltip target="salvarEmpenho" title="Salvar"></b-tooltip>
        </b-button>

        <b-button id="cancelarEmpenho" class=" my-2 ml-2" size="sm" pill variant="danger" @click="fecharModal">
          <b-icon icon="x-circle" />
          <b-tooltip target="cancelarEmpenho" title="Fechar"></b-tooltip>
        </b-button>

        <b-button v-if="this.form.id" class="my-2 ml-2" size="sm" id="removerEmpenho" pill variant="danger"
          @click="deleteAgregacao">
          <b-icon icon="trash"></b-icon>
          <b-tooltip target="removerEmpenho" title="Remover"></b-tooltip>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import LgFinderPageItemBemPermanente from "@/components/Finders/LgFinderPageItemBemPermanente.vue"
import LgFinderPageMotivoAgregacao from "@/components/Finders/LgFinderPageMotivoAgregacao.vue"
import ResourceService from "@/core/api/ResourceService"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import moment from "moment"
import { required } from "vuelidate/lib/validators"

export default {
  name: "ModalAgregacaoItemBemPermanente",
  components: {
    LgFinderPageMotivoAgregacao,
    LgFinderPageItemBemPermanente,
  },

  computed: {
  },
  props: {
    Ibp: {
      type: Object,
      required: true,
    },
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Agregação Item Bem Permanente",
    },
  },
  data() {
    return {
      mostrarModal: true,
      form: {
        numTombamentoSpalm: '',
        descricaoProduto: '',
        numTombamentoSamp: '',
        dataAgregacao: '',
        dataAgregacaoFormatado: '',
        descricao: '',
        motivo: {},
        itemBemPermanentePai: this.Ibp,
        itensBemPermanenteAgregacao: []
      },
      localIbp: this.Ibp,
      fields: [
        { key: 'numTombamento', label: 'Tombamento' },
        { key: 'numSerie', label: 'Nº Série' },
        { key: 'numero', label: 'Nº Produto' },
        { key: 'descricaoResumida', label: 'Descrição' },
        { key: 'actions', label: 'Ações' }
      ],
    }
  },
  validations: {
    form: {
      dataAgregacaoFormatado: { required },
      descricao: { required },
      motivo: { required },
    },
  },
  mixins: [ConfirmMixin, FormResourceMixin, ListResourceMixin],
  async beforeMount() {
    this.$service = new ResourceService(`/api/agregacao`)
    const { data } = await this.$service.findById(this.Ibp.id);
    this.busy = false;
    if (data) {
      data.dataAgregacaoFormatado = String(data.dataAgregacao).substring(0, 10);
      this.form = data
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    itemBemPermanenteSelect(item) {
      this.form.itensBemPermanenteAgregacao.push(item)
    },
    removeItem(item) {
      this.form.itensBemPermanenteAgregacao.splice(
        this.form.itensBemPermanenteAgregacao.indexOf(item),
        1
      );
    },
    fecharModal() {
      this.$emit('fecharModal')
    },
    async deleteAgregacao() {
      try {
        await this.$removeResource(this.form)
        this.fecharModal()
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Erro ao excluir a agregação`,
        })
        console.error(error)
      }
    },
    async submitForm() {
      if (!this.formIsValid) {
        this.$v.$touch()
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        })
        return
      }
      if (this.form.itensBemPermanenteAgregacao.length === 0) {
        this.$notify({
          type: "danger",
          message: "A lista de itens bem permanente da agregação não pode estar vazia.",
        })
        return
      }
      this.form.dataAgregacao = moment(this.form.dataAgregacaoFormatado).format('YYYY-MM-DDTHH:mm:ss')

      try {
        await this.$saveResource(
          this.form,
          "",
          true,
          {},
          this.isModal,
          true
        )
        this.fecharModal()
      } catch (error) {
        console.error("Erro ao salvar o registro:", error)
        this.$notify({
          type: "danger",
          message: `Erro ao salvar`,
        })
      }

    },
  },
}
</script>